<template>
  <div>
    <v-toolbar>  
      <v-menu
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon color="grey lighten-1">fa-list</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group>
            <v-list-item
              v-for="(item, i) in menuItems" 
              :key="`navdrawer${i}`" 
              :to="item.route"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" to="/">
            <v-icon color="grey lighten-1">fa-home</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('b_home') }}</span>
      </v-tooltip>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn v-for="(item, i) in menuItems" text :key="`menuitem${i}`" :to="item.route"> <!-- @click="increase" -->
          <v-icon 
            left 
            v-html="item.icon"
          >
          </v-icon>
          {{item.title}}
        </v-btn>
      </v-toolbar-items>
      <v-menu
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
          >
            <v-icon color="grey lighten-1">fa-language</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, i) in itemsLng"
            :key="i"
            @click="changeLang(item.act)"
          >
            <v-list-item-title>{{ item.lng }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        drawer: null,
        itemsLng: [
          { lng: "EN", act: "en" },
          { lng: "RU", act: "ru" }
        ],
      }
    },
    computed: {
      menuItems() {
        return [
          {
            icon: 'fa-portrait',
            title: this.$i18n.t('b_about'),
            route: '/about'
          },
          {
            icon: 'fa-newspaper',
            title: this.$i18n.t('b_articles'),
            route: '/articles'
          },
          {
            icon: 'fa-calendar-check',
            title: this.$i18n.t('b_events'),
            route: '/events'
          }
        ]
      }
    },
    methods:{
      changeLang: function(newLang){
        this.$locale.change(newLang)
      }
    }
  }
</script>

<style scoped>

</style>
